<template>
  <div class="order-source-pie">
    <div ref="container" style="width:100%;height:200px;"></div>
  </div>
</template>

<script>
  import Echart from 'echarts'
  import _ from 'lodash'
  export default {
    props: {
      percentList: {
        default () {
          return [
            {
              name: '咨询',
              value: 60
            },
            {
              name: '打错',
              value: 60
            },
            {
              name: '投诉',
              value: 60
            },
            {
              name: '紧急呼叫',
              value: 60
            },
            {
              name: '服务下单',
              value: 60
            }
          ]
        }
      }
    },
    mounted () {
      this.refresh()
    },
    methods: {
      refresh () {
        let option = {
          tooltip: {
            show: false
          },
          legend: {
            orient: 'vertical',
            x: 'right',
            data: _.map(this.percentList, e => e.name)
          },
          color: ['#2EC8CA', '#B6A2DF', '#5BB0F0', '#FFB880', '#D97A80'],
          clickable: false,
          series: [
            {
              silent: true,
              type: 'pie',
              radius: '70%',
              center: ['50%', '50%'],
              data: this.percentList
            }
          ]
        }
        if (this.chart) {
          this.chart.dispose()
        }
        let chart = Echart.init(this.$refs.container)
        chart.setOption(option)
        this.chart = chart
      }
    },
    watch: {
      percentList () {
        this.refresh()
      }
    }
  }
</script>
